import * as React from 'react';
import { SharedUiGalleryWrapper } from 'src/common/components/infosite/shared-ui/details/gallery-wrapper';
import { RefTarget } from '@shared-ui/ref-context';
// Gallery Components
export const PropertyGallery = () => React.createElement(RefTarget, {
  name: "Overview"
}, React.createElement(SharedUiGalleryWrapper, null));